var _rect, _rect2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.5,
    width: 5.5,
    height: 3,
    transform: "rotate(-90 0 5.5)",
    fill: "#36B4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 5.5,
    height: 3,
    transform: "rotate(-90 0 11)",
    fill: "#828585"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelected);
export default __webpack_public_path__ + "static/media/icon-selected.0675f01ec309f5b9198d1ce377e62869.svg";
export { ForwardRef as ReactComponent };